import { api, DynamicService } from 'utils/service';

import {
  API_USER_PATIENT_PROFILE_SESSIONS_SURGERIES,
  CreateBulkUserPatientProfileSessionSurgeryInput,
  UserPatientProfileSessionSurgery,
} from './models';

export * from './models';

class Service extends DynamicService<UserPatientProfileSessionSurgery> {
  createBulk = (input: CreateBulkUserPatientProfileSessionSurgeryInput) => {
    return api.post(API_USER_PATIENT_PROFILE_SESSIONS_SURGERIES.POST_BULK, {
      mainID: input.userPatientProfileSessionID,
      itemIDs: input.surgeryIDs,
    });
  };
}

export const ServiceUserPatientProfileSessionsSurgeries = new Service({
  mainField: 'id',
  getAll: API_USER_PATIENT_PROFILE_SESSIONS_SURGERIES.GET_ALL_DYNAMIC,
  post: API_USER_PATIENT_PROFILE_SESSIONS_SURGERIES.POST,
  delete: API_USER_PATIENT_PROFILE_SESSIONS_SURGERIES.DELETE,
  patch: API_USER_PATIENT_PROFILE_SESSIONS_SURGERIES.PATCH,
});
